// @owners { team: patients-team }
import { getShipmentPaymentMethodsWithDetails } from '~shared/features/payments/selectors/getShipmentPaymentMethods';
import { type ReduxStateShared } from '~shared/types';

export const getSelectedPaymentMethod = (state: ReduxStateShared, shipmentID: number) =>
  getShipmentPaymentMethodsWithDetails(state, {
    shipmentID,
  });
